export const WORDS = [
  'teorem', //fri
  'ciuman', //sat
  'mereka', //sun -act mon if -1
  'tolong', //mon
  'burung',
  'belang',
  'jangan', //tue
  'kancil',
  'coklat',
  'tandas',
  'ketawa', //wed
  'nyamuk',
  'tompok', //fri - act sat
  'kenapa', //sat - act mon
  'sardin',
  'siakap',
  'kerang',
  'sotong',
  'kerapu',
  'kerisi', //sun - act tue
  'terima', //mon 
  'pernah',
  'banyak',
  'keluar',
  'begitu',
  'dengar', 
  'korban', //monday
  'wanita', //tue
  'paling', //wed
  'sayang', //THU
  'haiwan', //fri
  'adalah', //sat
  'kerbau', 
  'meriah', //thurs
  'sayang',
  'lelaki', //thurs
  'tunggu',
  'sedang',
  'nampak',
  'tempat',
  'monyet', //wed?
  'berada', //thu?
  'tetapi', //fri
  'bahawa', //sat
  'sakura', //mon
  'gunung',
  'kereta',
  'menang',
  'sekali',
  'sampai',
  'ketika',
  'maksud',
  'tengok',
  'tangan',
  'berapa',
  'selalu',
  'pulang',
  'dengan',
  'beliau',
  'bandar',
  'berdua',
  'hilang',
  'sahaja',
  'kalian',
  'kucing',
  'cantik',
  'semasa',
  'secara',
  'hampir',
  'kepala',
  'tembak',
  'bangun',
  'antara',
  'negara',
  'kapten',
  'supaya',
  'memang',
  'isteri',
  'minggu',
  'khabar',
  'cerita',
  'anjing',
  'begini',
  'doktor',
  'tinggi',
  'hantar',
  'peduli',
  'segera',
  'kurang',
  'berita',
  'perang',
  'serius',
  'nombor',
  'tengah',
  'berani',
  'rahsia',
  'gambar',
  'soalan',
  'tenang',
  'senang',
  'barang',
  'bahasa',
  'celaka',
  'pegang',
  'peluru',
  'bilang',
  'muncul',
  'sistem',
  'setuju',
  'sesuai',
  'bahaya',
  'hadiah',
  'pistol',
  'arahan',
  'angkat',
  'neraka',
  'segala',
  'alasan',
  'dahulu',
  'alamak',
  'simpan',
  'kosong',
  'rambut',
  'kamera',
  'sentuh',
  'pedang',
  'betapa',
  'selain',
  'cahaya',
  'hingga',
  'bicara',
  'tenaga',
  'laluan',
  'pandai',
  'sangka',
  'menipu',
  'daging',
  'urusan',
  'tujuan',
  'planet',
  'lubang',
  'rendah',
  'lokasi',
  'rakyat',
  'sampah',
  'dendam',
  'pantas',
  'saling',
  'anggap',
  'majlis',
  'sungai',
  'cedera',
  'hendak',
  'pantai',
  'bangga',
  'teriak',
  'langit',
  'sebaik',
  'tetamu',
  'engkau',
  'serang',
  'tukang',
  'impian',
  'lambat',
  'minyak',
  'mangsa',
  'petang',
  'potong',
  'sering',
  'peguam',
  'puteri',
  'sumber',
  'seluar',
  'tunduk',
  'pindah',
  'ketiga',
  'negeri',
  'hujung',
  'selesa',
  'selagi',
  'bersih',
  'stesen',
  'kerusi',
  'normal',
  'tulang',
  'gereja',
  'hormat',
  'kertas',
  'jumlah',
  'takdir',
  'dewasa',
  'halang',
  'bentuk',
  'daerah',
  'posisi',
  'patung',
  'ganggu',
  'cincin',
  'istana',
  'syurga',
  'lantai',
  'menara',
  'tangga',
  'pusing',
  'risiko',
  'berdoa',
  'kacang',
  'polisi',
  'cermin',
  'lautan',
  'pintar',
  'siasat',
  'lancar',
  'kecewa',
  'suspek',
  'sertai',
  'diberi',
  'tarian',
  'hancur',
  'lompat',
  'putera',
  'makmal',
  'pendek',
  'lembut',
  'malang',
  'mainan',
  'kaitan',
  'sumpah',
  'bohong',
  'tempoh',
  'terang',
  'talian',
  'alamat',
  'musnah',
  'miliki',
  'pasang',
  'kahwin',
  'campur',
  'tarikh',
  'sembuh',
  'bidang',
  'projek',
  'miskin',
  'jemput',
  'ucapan',
  'topeng',
  'tunjuk',
  'proses',
  'sepupu',
  'hidung',
  'senyum',
  'padang',
  'dibuka',
  'senyap',
  'jarang',
  'kilang',
  'tambah',
  'lengan',
  'jangka',
  'sambil',
  'hutang',
  'bangsa',
  'ladang',
  'bising',
  'memori',
  'contoh',
  'sempat',
  'terjun',
  'ikatan',
  'bagian',
  'bimbit',
  'kuning',
  'kongsi',
  'bagiku',
  'sultan',
  'kiraan',
  'kering',
  'stabil',
  'paderi',
  'ciuman',
  'dingin',
  'butang',
  'keldai',
  'gudang',
  'khusus',
  'pentas',
  'akibat',
  'pinjam',
  'hangat',
  'kajian',
  'keliru',
  'enggan',
  'ulangi',
  'akhbar',
  'teknik',
  'darjah',
  'ringan',
  'jadual',
  'afrika',
  'pingat',
  'tembok',
  'bateri',
  'batang',
  'eropah',
  'syarat',
  'lorong',
  'remaja',
  'puncak',
  'tumbuh',
  'hargai',
  'perahu',
  'rantai',
  'simbol',
  'kredit',
  'markas',
  'sarkas',
  'daftar',
  'sarang',
  'rasuah',
  'jenaka',
  'tangki',
  'subjek',
  'siaran',
  'almari',
  'tampak',
  'dompet',
  'junior',
  'meriam',
  'mampus',
  'ribuan',
  'sarung',
  'senior',
  'status',
  'rumput',
  'renang',
  'loceng',
  'dapati',
  'goreng',
  'seribu',
  'tampan',
  'teliti',
  'moyang',
  'rampas',
  'agensi',
  'kembar',
  'jumaat',
  'syabas',
  'terbit',
  'bilion',
  'tombak',
  'sekian',
  'mundur',
  'tonton',
  'buatan',
  'maruah',
  'kasino',
  'lanjut',
  'aliran',
  'naluri',
  'kadang',
  'jerung',
  'kokain',
  'produk',
  'runtuh',
  'pujian',
  'serupa',
  'lenyap',
  'biskut',
  'mental',
  'klasik',
  'sosial',
  'baunya',
  'terapi',
  'tumbuk',
  'sekutu',
  'umpama',
  'buddha',
  'muzium',
  'lumpur',
  'sakiti',
  'atasan',
  'selasa',
  'memuat',
  'kerdil',
  'jantan',
  'episod',
  'reaksi',
  'budaya',
  'betina',
  'nyonya',
  'helang',
  'rahmat',
  'markah',
  'gelang',
  'kanser',
  'upahan',
  'sesuka',
  'kampus',
  'lembah',
  'lintas',
  'matang',
  'cubaan',
  'tampar',
  'anggur',
  'burger',
  'baling',
  'studio',
  'teater',
  'puting',
  'selera',
  'santai',
  'global',
  'kaedah',
  'sidang',
  'payung',
  'serbuk',
  'nyanyi',
  'jutaan',
  'boneka',
  'pintas',
  'pisang',
  'tindak',
  'kostum',
  'kungfu',
  'bagimu',
  'kuliah',
  'nyaman',
  'aturan',
  'heroin',
  'pantat',
  'rompak',
  'trauma',
  'lampau',
  'handal',
  'borang',
  'bacaan',
  'jagung',
  'manual',
  'portal',
  'sektor',
  'tunang',
  'asrama',
  'pening',
  'warden',
  'nyaris',
  'periuk',
  'kurung',
  'cacing',
  'campak',
  'hendap',
  'berkat',
  'khemah',
  'taktik',
  'curiga',
  'diraja',
  'sempit',
  'kenali',
  'kiamat',
  'visual',
  'wayang',
  'hasrat',
  'ukuran',
  'beribu',
  'tebing',
  'lumpuh',
  'gedung',
  'tegang',
  'baring',
  'fungsi',
  'punyai',
  'pondok',
  'lempar',
  'cecair',
  'krisis',
  'fahami',
  'sambut',
  'mentah',
  'urutan',
  'haluan',
  'kesian',
  'bantal',
  'tanduk',
  'kelima',
  'marikh',
  'untung',
  'takhta',
  'cerdas',
  'jadian',
  'bawang',
  'kakiku',
  'pastur',
  'jurang',
  'magnet',
  'ikhlas',
  'kelabu',
  'kelapa',
  'timbul',
  'keping',
  'konsep',
  'trafik',
  'banjir',
  'tablet',
  'duyung',
  'ritual',
  'bunian',
  'bujang',
  'ibarat',
  'utusan',
  'petrol',
  'armada',
  'hairan',
  'adegan',
  'swasta',
  'rekaan',
  'relaks',
  'aduhai',
  'kursus',
  'rangka',
  'muatan',
  'panjat',
  'jalani',
  'lapang',
  'sutera',
  'klinik',
  'ganjil',
  'buruan',
  'penuhi',
  'tekaan',
  'gerudi',
  'tabiat',
  'muslim',
  'dalang',
  'respon',
  'ijazah',
  'kumpul',
  'sengit',
  'amatur',
  'maklum',
  'memuji',
  'dialog',
  'kemudi',
  'meriah',
  'kalung',
  'jagaan',
  'sokong',
  'prebet',
  'musang',
  'cerdik',
  'tampil',
  'tomato',
  'meteor',
  'undian',
  'dekati',
  'dakwat',
  'ketara',
  'jenama',
  'khamis',
  'ramuan',
  'alatan',
  'dahaga',
  'tempah',
  'pencen',
  'sundal',
  'bagasi',
  'undang',
  'pelari',
  'wasiat',
  'tombol',
  'konvoi',
  'sukses',
  'berkas',
  'sulung',
  'signal',
  'azimat',
  'kentut',
  'sensor',
  'karier',
  'spesis',
  'sepatu',
  'curang',
  'profil',
  'harian',
  'bayang',
  'broker',
  'ketemu',
  'taufan',
  'kepung',
  'tabung',
  'kempen',
  'jurnal',
  'tiarap',
  'piring',
  'tuanya',
  'syukur',
  'taksub',
  'poster',
  'loteng',
  'tempur',
  'kartel',
  'kaisar',
  'kuwait',
  'raikan',
  'faedah',
  'tiruan',
  'persis',
  'cakera',
  'sampul',
  'servis',
  'elemen',
  'vaksin',
  'kuasai',
  'hiasan',
  'pemacu',
  'dayung',
  'khayal',
  'kompas',
  'jaring',
  'gangsa',
  'fesyen',
  'rayuan',
  'siling',
  'jejaka',
  'bebola',
  'gorila',
  'agenda',
  'benang',
  'kerang',
  'spring',
  'sotong',
  'karang',
  'loghat',
  'mantan',
  'keluli',
  'lembik',
  'lembab',
  'kapsul',
  'siuman',
  'bangku',
  'luncur',
  'nikmat',
  'runcit',
  'mertua',
  'amanah',
  'keenam',
  'akhiri',
  'dibaca',
  'masjid',
  'kartun',
  'godaan',
  'galeri',
  'puding',
  'karate',
  'suntik',
  'hanyut',
  'ajaran',
  'carian',
  'ambang',
  'faktor',
  'apatah',
  'besbol',
  'gelung',
  'jamuan',
  'isinya',
  'binasa',
  'antena',
  'gandum',
  'kondom',
  'amalan',
  'patuhi',
  'suntuk',
  'melayu',
  'silang',
  'mantap',
  'kokpit',
  'layari',
  'tragis',
  'formal',
  'nurani',
  'rentak',
  'apinya',
  'mutlak',
  'kodnya',
  'koloni',
  'ulasan',
  'kriket',
  'jelaga',
  'violet',
  'ugutan',
  'hangus',
  'hadiri',
  'tembus',
  'larang',
  'lampin',
  'ajukan',
  'rahang',
  'kejang',
  'angkuh',
  'muflis',
  'garang',
  'jejaki',
  'apahal',
  'kemeja',
  'vagina',
  'setahu',
  'kastam',
  'karpet',
  'bernas',
  'taring',
  'resipi',
  'pidato',
  'mangga',
  'tepung',
  'sumbat',
  'lintah',
  'firman',
  'unggun',
  'sedari',
  'ternak',
  'celana',
  'firaun',
  'isikan',
  'dugaan',
  'pondan',
  'gulung',
  'karbon',
  'helium',
  'goyang',
  'unggul',
  'skuter',
  'mistik',
  'jerami',
  'maskot',
  'lembap',
  'resort',
  'tepati',
  'hentam',
  'morfin',
  'karung',
  'alergi',
  'pimpin',
  'psikik',
  'kunyah',
  'treler',
  'tumpah',
  'poskad',
  'luaran',
  'bridge',
  'belati',
  'radius',
  'pautan',
  'cabang',
  'rekrut',
  'permit',
  'loteri',
  'gentar',
  'bandit',
  'purata',
  'melulu',
  'protes',
  'ejekan',
  'banget',
  'hormon',
  'pereka',
  'gendut',
  'tuntut',
  'lontar',
  'mancis',
  'bikini',
  'dukung',
  'ukiran',
  'arteri',
  'balang',
  'pusaka',
  'bahagi',
  'baharu',
  'perisa',
  'hitung',
  'tadika',
  'cermat',
  'plasma',
  'potret',
  'dimuat',
  'rumpai',
  'biadab',
  'cokmar',
  'asuhan',
  'kuntum',
  'pensel',
  'selari',
  'kening',
  'amarah',
  'murung',
  'merana',
  'alahan',
  'telaga',
  'ekstra',
  'sampan',
  'bersin',
  'koktel',
  'makmur',
  'gejala',
  'denyut',
  'buatku',
  'belaka',
  'dorong',
  'bantah',
  'platun',
  'preman',
  'buatmu',
  'tragik',
  'konsul',
  'masing',
  'santun',
  'selaju',
  'rezeki',
  'sembah',
  'ampuni',
  'idaman',
  'jelita',
  'melodi',
  'perigi',
  'temani',
  'statik',
  'kerani',
  'salmon',
  'kiasan',
  'kantin',
  'diesel',
  'anggun',
  'syampu',
  'renung',
  'import',
  'turuti',
  'takuti',
  'renjer',
  'ketiak',
  'lincah',
  'cairan',
  'humban',
  'slogan',
  'warung',
  'juvana',
  'palang',
  'jernih',
  'tumpul',
  'pantau',
  'sangsi',
  'habuan',
  'piknik',
  'entiti',
  'grafik',
  'rantau',
  'tiupan',
  'kritis',
  'separa',
  'komedi',
  'ginjal',
  'turbin',
  'pelawa',
  'zaitun',
  'ingkar',
  'toksik',
  'tumpas',
  'tiduri',
  'mercun',
  'dibuli',
  'dengki',
  'marina',
  'elegan',
  'sengat',
  'toksin',
  'ironis',
  'tudung',
  'hikmat',
  'gurita',
  'ubatan',
  'anjung',
  'bangau',
  'jenguk',
  'batuan',
  'iringi',
  'tender',
  'buaian',
  'ilmiah',
  'lantik',
  'dilema',
  'kagumi',
  'cadang',
  'acukan',
  'landas',
  'catuan',
  'raptai',
  'daulat',
  'hadnya',
  'gading',
  'derita',
  'dicuba',
  'teruna',
  'nafkah',
  'sardin',
  'pancut',
  'jemaah',
  'pabrik',
  'kafein',
  'seusia',
  'guaman',
  'sperma',
  'nebula',
  'walkie',
  'dering',
  'kurnia',
  'cergas',
  'marmar',
  'mortar',
  'premis',
  'dihuni',
  'ranjau',
  'ketuai',
  'mentol',
  'binaan',
  'landak',
  'cambuk',
  'pancit',
  'syahid',
  'suapan',
  'tandus',
  'tipuan',
  'biskop',
  'isotop',
  'lumrah',
  'limpah',
  'rongga',
  'bertih',
  'domino',
  'sandal',
  'samara',
  'pujaan',
  'laknat',
  'tampal',
  'delima',
  'lantas',
  'adinda',
  'bendul',
  'tenung',
  'kincir',
  'ungkit',
  'gerila',
  'alunan',
  'baligh',
  'proton',
  'pesara',
  'layang',
  'pudina',
  'kaleng',
  'deputi',
  'corong',
  'konsol',
  'posmen',
  'kontra',
  'materi',
  'halaju',
  'nitrat',
  'gundik',
  'keruan',
  'tebang',
  'kecapi',
  'jelata',
  'selang',
  'tebuan',
  'parang',
  'bulbul',
  'sulfur',
  'nisbah',
  'vanila',
  'kanvas',
  'piagam',
  'kalori',
  'jagoan',
  'kismis',
  'bawaan',
  'kental',
  'rempah',
  'bengis',
  'pesona',
  'magang',
  'jingga',
  'tinjau',
  'tempuh',
  'berupa',
  'bintik',
  'lewati',
  'voltan',
  'zamrud',
  'ikutan',
  'banglo',
  'alahai',
  'ngarai',
  'angkut',
  'rohani',
  'asmara',
  'loncat',
  'fitnah',
  'ayunan',
  'lelong',
  'kelasi',
  'kurita',
  'kenari',
  'rendam',
  'sengal',
  'hinaan',
  'boring',
  'rangup',
  'cucian',
  'albino',
  'dulang',
  'dikata',
  'zodiak',
  'dialek',
  'boling',
  'terung',
  'sebati',
  'sekoci',
  'puitis',
  'medium',
  'hembus',
  'retina',
  'lenang',
  'sembur',
  'gertak',
  'stereo',
  'sendok',
  'drebar',
  'hubung',
  'hadang',
  'bongsu',
  'keriut',
  'bongok',
  'gunaan',
  'radang',
  'empati',
  'hingus',
  'krayon',
  'pelana',
  'indeks',
  'taurat',
  'lendir',
  'semata',
  'safari',
  'hentak',
  'taubat',
  'binari',
  'spirit',
  'kronik',
  'lambai',
  'pendua',
  'pendam',
  'buasir',
  'anarki',
  'cemeti',
  'kusyen',
  'segmen',
  'embrio',
  'gabung',
  'sekata',
  'rabung',
  'pacuan',
  'jejari',
  'akhlak',
  'lesung',
  'jeriji',
  'garing',
  'menaik',
  'kenyal',
  'ingati',
  'lembar',
  'hektar',
  'peluit',
  'gagang',
  'lengah',
  'kritik',
  'serban',
  'paduka',
  'anemia',
  'lastik',
  'tutupi',
  'masihi',
  'subang',
  'berang',
  'takluk',
  'guling',
  'paspor',
  'vektor',
  'neuron',
  'vendor',
  'lantak',
  'angguk',
  'seruan',
  'tuaian',
  'keladi',
  'rempuh',
  'kaktus',
  'simpul',
  'pelita',
  'baptis',
  'sesali',
  'dagang',
  'lingga',
  'wahana',
  'adunan',
  'oksida',
  'brandi',
  'talkie',
  'pastri',
  'borgol',
  'bokong',
  'lereng',
  'montel',
  'siulan',
  'botani',
  'tedung',
  'metrik',
  'glamor',
  'mandul',
  'buncit',
  'kijang',
  'wakili',
  'sewaan',
  'makian',
  'curian',
  'jempol',
  'format',
  'buntut',
  'hadkan',
  'tayang',
  'balian',
  'alihan',
  'tampuk',
  'aksara',
  'ibunda',
  'bolong',
  'unggas',
  'menahu',
  'granit',
  'penaik',
  'rancak',
  'lenyek',
  'lembur',
  'tompok',
  'darwis',
  'kendur',
  'dandan',
  'berahi',
  'cemara',
  'hambar',
  'hanyir',
  'renjat',
  'duduki',
  'kenang',
  'haknya',
  'sandar',
  'pangsa',
  'sabung',
  'gemari',
  'pateri',
  'meraba',
  'bareng',
  'galian',
  'hayati',
  'semahu',
  'bualan',
  'ibadah',
  'klorin',
  'pasrah',
  'maksum',
  'termos',
  'hidang',
  'sejoli',
  'alukan',
  'algojo',
  'kudrat',
  'darjat',
  'ingini',
  'selami',
  'sahara',
  'peking',
  'juling',
  'bersut',
  'kesali',
  'miring',
  'laguku',
  'borong',
  'pinang',
  'tasbih',
  'catnya',
  'gempal',
  'jerlus',
  'rintik',
  'restui',
  'jerebu',
  'sepuas',
  'paduan',
  'lohong',
  'warisi',
  'ambisi',
  'kuping',
  'bentar',
  'sindir',
  'piawai',
  'cuping',
  'biayai',
  'dampak',
  'alkali',
  'celaru',
  'bancuh',
  'beroda',
  'penyek',
  'peparu',
  'blazer',
  'lambak',
  'lawati',
  'anggar',
  'tajaan',
  'lembek',
  'korset',
  'amplop',
  'luahan',
  'gempar',
  'talkin',
  'baghal',
  'siakap',
  'sambar',
  'takjub',
  'kalium',
  'ereksi',
  'playar',
  'cognac',
  'luntur',
  'barium',
  'igauan',
  'sigung',
  'bahlul',
  'pandir',
  'sudahi',
  'bampar',
  'sumsum',
  'durian',
  'bandel',
  'erotik',
  'tindik',
  'enteng',
  'belian',
  'natang',
  'sulang',
  'indera',
  'dayang',
  'joging',
  'meluap',
  'dempul',
  'hikmah',
  'girang',
  'pahala',
  'jamban',
  'utopia',
  'kekuda',
  'busana',
  'perban',
  'pemaaf',
  'invois',
  'briged',
  'polong',
  'aniaya',
  'sajian',
  'insang',
  'hindar',
  'atrium',
  'stigma',
  'habeas',
  'kompos',
  'racuni',
  'barter',
  'fosfat',
  'bahang',
  'senget',
  'bangka',
  'tambat',
  'engsel',
  'titian',
  'biawak',
  'sepagi',
  'simbah',
  'mandat',
  'ketuat',
  'jeruji',
  'tehran',
  'bijian',
  'pungut',
  'tepian',
  'serbet',
  'sorong',
  'skuasy',
  'anting',
  'lintar',
  'primer',
  'tocang',
  'tembam',
  'litium',
  'tafsir',
  'pawang',
  'bengap',
  'jakuzi',
  'seteru',
  'lalang',
  'serong',
  'postur',
  'bengal',
  'kempis',
  'arloji',
  'senter',
  'mendap',
  'rungut',
  'mazhab',
  'halkum',
  'pemuka',
  'limbah',
  'ambing',
  'hempap',
  'kekang',
  'mampat',
  'mereda',
  'satuan',
  'tandai',
  'rentas',
  'kanyon',
  'pigmen',
  'kuncup',
  'kudeta',
  'kanopi',
  'tungku',
  'bundar',
  'lejang',
  'monsun',
  'empedu',
  'cetera',
  'dihidu',
  'dinaik',
  'mengah',
  'sketsa',
  'siakan',
  'zuriat',
  'testis',
  'semput',
  'adopsi',
  'talkum',
  'relang',
  'lajang',
  'ungkap',
  'pintal',
  'rentan',
  'storan',
  'kolera',
  'aising',
  'usikan',
  'gawang',
  'aikido',
  'steril',
  'jintan',
  'zuhrah',
  'pagoda',
  'jeling',
  'uncang',
  'napkin',
  'murtad',
  'netral',
  'hijrah',
  'milyar',
  'kenyit',
  'jentik',
  'timbal',
  'bazuka',
  'himpit',
  'figura',
  'cipnya',
  'edaran',
  'digaji',
  'rentap',
  'diawet',
  'pancur',
  'gerutu',
  'galang',
  'melati',
  'tambak',
  'tertib',
  'bohsia',
  'ampere',
  'ibadat',
  'hatrik',
  'bering',
  'hajati',
  'hering',
  'esakan',
  'perayu',
  'pedati',
  'buntal',
  'tarkas',
  'hantam',
  'dengus',
  'lenguh',
  'tandan',
  'syawal',
  'kadbod',
  'memacu',
  'garuda',
  'cacian',
  'teruji',
  'senduk',
  'fiskal',
  'sepina',
  'sepana',
  'realis',
  'hempas',
  'noktah',
  'balkon',
  'gelita',
  'pukang',
  'podium',
  'tendon',
  'opsyen',
  'landai',
  'grafit',
  'berudu',
  'renyah',
  'tabrak',
  'hening',
  'sentak',
  'hostel',
  'biasan',
  'cereka',
  'terjah',
  'amanat',
  'ziarah',
  'dedalu',
  'aksiom',
  'bandul',
  'astaka',
  'selada',
  'kobalt',
  'imbang',
  'lamban',
  'giring',
  'pusara',
  'sulfat',
  'sergah',
  'boikot',
  'sentri',
  'sumpit',
  'wacana',
  'aseton',
  'gundah',
  'andong',
  'buncis',
  'kerapu',
  'topang',
  'tindih',
  'ranggi',
  'bender',
  'proksi',
  'tindas',
  'tengik',
  'pencil',
  'beting',
  'tuntun',
  'kosmos',
  'brosur',
  'susuri',
  'uranus',
  'rupiah',
  'mampan',
  'suling',
  'gandar',
  'mentua',
  'dahlia',
  'cekcok',
  'tarbil',
  'talang',
  'poskod',
  'jargon',
  'mandir',
  'takrif',
  'kedana',
  'kampai',
  'tempel',
  'gambut',
  'akalku',
  'tuding',
  'palung',
  'feudal',
  'beraja',
  'tenusu',
  'sampar',
  'dongak',
  'brunei',
  'melaut',
  'uterus',
  'bantai',
  'glukos',
  'agihan',
  'pidana',
  'hangit',
  'lentur',
  'saderi',
  'kariah',
  'sarhad',
  'sental',
  'rektor',
  'rektum',
  'ceburi',
  'fabrik',
  'wallah',
  'ekuiti',
  'adapun',
  'pangan',
  'kandas',
  'guntur',
  'zionis',
  'juadah',
  'wapnya',
  'mukmin',
  'silika',
  'renyai',
  'sengih',
  'terkam',
  'sambal',
  'lencun',
  'renyuk',
  'tancap',
  'dogeng',
  'bordir',
  'kancah',
  'absurd',
  'fitrah',
  'bebiri',
  'linear',
  'tetuan',
  'pijama',
  'jangat',
  'gasang',
  'kurier',
  'emping',
  'kepang',
  'kunyit',
  'gayung',
  'sesawi',
  'beling',
  'takbir',
  'kontan',
  'bionik',
  'gelora',
  'dipacu',
  'rengsa',
  'herdik',
  'mondok',
  'celeng',
  'mayang',
  'tekong',
  'rencat',
  'sentap',
  'randah',
  'relasi',
  'gewang',
  'turuni',
  'pengap',
  'merugi',
  'kimpal',
  'warnai',
  'bebuli',
  'banter',
  'penama',
  'inayat',
  'tangis',
  'bening',
  'tiroid',
  'gosong',
  'bakhil',
  'tanggo',
  'bercak',
  'bobrok',
  'walhal',
  'agresi',
  'gasing',
  'kuprum',
  'aibkan',
  'badang',
  'kemung',
  'enggak',
  'tadbir',
  'montok',
  'dinamo',
  'engkol',
  'bangar',
  'gamkan',
  'denyar',
  'rutbir',
  'hujani',
  'rampok',
  'hidrat',
  'balast',
  'tokong',
  'teraju',
  'ongkos',
  'korona',
  'riasan',
  'tundra',
  'wantan',
  'dibaik',
  'gerigi',
  'benjol',
  'gering',
  'lengai',
  'median',
  'jambak',
  'relung',
  'prisma',
  'giling',
  'bonbon',
  'jibril',
  'celaan',
  'pangsi',
  'peniti',
  'hantuk',
  'gempur',
  'meruap',
  'khatan',
  'hidapi',
  'sampat',
  'takbur',
  'teleks',
  'pinset',
  'dibiar',
  'oktana',
  'baucar',
  'azimut',
  'barbar',
  'kiblat',
]
